<template>
  <header>
    <!-- Main Nav -->
    <div class="bg-transparent absolute top-0 left-0 w-full z-50">
      <div
        class="px-2 lg:px-6 max-w-screen-2xl mx-auto flex justify-between items-center py-4"
      >
        <!-- Logo -->
        <div class="text-white text-3xl px-4 lg:px-2">
          <router-link to="/">
            <img
              src="../assets/images/LOGO RESIZE (1).png"
              alt="Mshel Homes"
              class="lg:h-14 h-10"
            />
          </router-link>
        </div>

        <!-- Desktop Nav -->
        <nav class="hidden lg:flex items-center space-x-6 relative z-50">
          <router-link
            to="/"
            class="text-white transition-all duration-300"
            exact-active-class="active-link"
            >Home</router-link
          >

          <!-- About Dropdown for Desktop -->
          <div
            class="relative group cursor-pointer"
            :class="{ 'active-link': isAboutActive }"
          >
            <div
              class="text-white px-5 inline-flex items-center transition-all duration-300"
            >
              About Us
              <svg
                class="w-2.5 h-2.5 ms-3"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 10 6"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 4 4 4-4"
                />
              </svg>
            </div>
            <div
              id="dropdownHover"
              class="hidden group-hover:block absolute left-0 z-50 bg-yellow bg-opacity-70 divide-y divide-white shadow-lg w-44"
            >
              <ul class="py-3 text-sm text-white">
                <li>
                  <router-link
                    to="/about"
                    class="block px-4 py-3 hover:bg-white hover:text-black"
                    >About</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/achievements"
                    class="block px-4 py-3 hover:bg-white hover:text-black"
                    >Achievements</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/services"
                    class="block px-4 py-3 hover:bg-white hover:text-black"
                    >Services</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/career"
                    class="block px-4 py-3 hover:bg-white hover:text-black"
                    >Career</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/faq"
                    class="block px-4 py-3 hover:bg-white hover:text-black"
                    >FAQ</router-link
                  >
                </li>
              </ul>
            </div>
          </div>

          <!-- Properties Dropdown for Desktop -->
          <div
            class="relative group cursor-pointer"
            :class="{ 'active-link': isPropertiesActive }"
          >
            <div
              class="text-white px-5 inline-flex items-center transition-all duration-300"
            >
              Properties
              <svg
                class="w-2.5 h-2.5 ms-3"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 10 6"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 4 4 4-4"
                />
              </svg>
            </div>
            <div
              id="dropdownHover"
              class="hidden group-hover:block absolute left-0 z-50 bg-yellow bg-opacity-70 divide-y divide-white shadow-lg w-44"
            >
              <ul class="py-3 text-sm text-white">
                <li>
                  <router-link
                    to="/ultra"
                    class="block px-4 py-3 hover:bg-white hover:text-black"
                    >Ultra</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/sites-and-services"
                    class="block px-4 py-3 hover:bg-white hover:text-black"
                    >Sites & Services</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/third-party-sale"
                    class="block px-4 py-3 hover:bg-white hover:text-black"
                    >Third Party Sale</router-link
                  >
                </li>
              </ul>
            </div>
          </div>

          <!-- Branches Dropdown for Desktop -->
          <div
            class="relative group cursor-pointer"
            :class="{ 'active-link': isBranchesActive }"
          >
            <div
              class="text-white px-5 inline-flex items-center transition-all duration-300"
            >
              Branches
              <svg
                class="w-2.5 h-2.5 ms-3"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 10 6"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 4 4 4-4"
                />
              </svg>
            </div>
            <div
              id="dropdownHover"
              class="hidden group-hover:block absolute left-0 z-50 bg-yellow bg-opacity-70 divide-y divide-white shadow-lg w-44"
            >
              <ul class="py-3 text-sm text-white">
                <li>
                  <router-link
                    to="/lagos-branch"
                    class="block px-4 py-3 hover:bg-white hover:text-black"
                    >Lagos Branch</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/kano-branch"
                    class="block px-4 py-3 hover:bg-white hover:text-black"
                    >Kano Branch</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/yola-branch"
                    class="block px-4 py-3 hover:bg-white hover:text-black"
                    >Yola Branch</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <router-link
            to="/contact-us"
            class="text-white transition-all duration-300"
            exact-active-class="active-link"
            >Contact</router-link
          >

          <!-- Login Dropdown for Desktop -->
          <div
            class="relative group cursor-pointer"
            :class="{ 'active-link': isLoginActive }"
          >
            <div
              class="text-white px-5 inline-flex items-center transition-all duration-300"
            >
              Login
              <svg
                class="w-2.5 h-2.5 ms-3"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 10 6"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 4 4 4-4"
                />
              </svg>
            </div>
            <div
              id="dropdownHover"
              class="hidden group-hover:block absolute left-0 z-50 bg-yellow bg-opacity-70 divide-y divide-white shadow-lg w-44"
            >
              <ul class="py-3 text-sm text-white">
                <li>
                  <a
                    href="https://app.mshelhomes.com/login"
                    target="_blank"
                    class="block px-4 py-3 hover:bg-white hover:text-black"
                    >Staff</a
                  >
                </li>
                <li>
                  <a
                    href="https://app.mshelhomes.com/client-login"
                    target="_blank"
                    class="block px-4 py-3 hover:bg-white hover:text-black"
                    >Client</a
                  >
                </li>
              </ul>
            </div>
          </div>

          <!-- Register Dropdown for Desktop -->
          <div
            class="relative group cursor-pointer"
            :class="{ 'active-link': isRegisterActive }"
          >
            <div
              class="text-white px-5 inline-flex items-center transition-all duration-300"
            >
              Register
              <svg
                class="w-2.5 h-2.5 ms-3"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 10 6"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 4 4 4-4"
                />
              </svg>
            </div>
            <div
              id="dropdownHover"
              class="hidden group-hover:block absolute left-0 z-50 bg-yellow bg-opacity-70 divide-y divide-white shadow-lg w-44"
            >
              <ul class="py-3 text-sm text-white">
                <li>
                  <a
                    href="https://app.mshelhomes.com/login"
                    target="_blank"
                    class="block px-4 py-3 hover:bg-white hover:text-black"
                    >Staff</a
                  >
                </li>
                <li>
                  <a
                    href="https://app.mshelhomes.com/client-login"
                    target="_blank"
                    class="block px-4 py-3 hover:bg-white hover:text-black"
                    >Client</a
                  >
                </li>
              </ul>
            </div>
          </div>

          <!-- Button (Inside Toggle on Mobile) -->
          <router-link to="/earn-with-us">
            <button
              class="bg-white py-2 px-2 hover:bg-yellow hover:text-white transition-transform transform hover:scale-110 focus:outline-none focus:ring-4"
            >
              Earn with us
            </button>
          </router-link>
        </nav>

        <!-- Mobile Menu Button -->
        <div class="lg:hidden">
          <button
            @click.prevent="toggleMenu"
            class="text-white focus:outline-none actives-link"
          >
            <i v-if="!isMenuOpen" class="fa-solid fa-bars w-10 h-10"></i>
            <i v-else class="fa-solid fa-xmark w-10 h-10"></i>
          </button>
        </div>
      </div>

      <!-- Mobile Nav -->
       <div class="px-2">
         <div v-if="isMenuOpen" class="bg-white lg:hidden px-4 rounded-lg shadow-lg">
           <nav class="flex flex-col space-y-4 py-4 px-2 text-black">
             <router-link to="/" class="transition-all duration-300"
               >Home</router-link
             >
             <!-- About Dropdown for Mobile -->
             <div class="relative">
               <div
                 @click="toggleDropdownAbout"
                 class="text-black flex items-center transition-all duration-300"
               >
                 About
                 <svg
                   class="w-2.5 h-2.5 ms-3"
                   xmlns="http://www.w3.org/2000/svg"
                   fill="none"
                   viewBox="0 0 10 6"
                 >
                   <path
                     stroke="currentColor"
                     stroke-linecap="round"
                     stroke-linejoin="round"
                     stroke-width="2"
                     d="m1 1 4 4 4-4"
                   />
                 </svg>
               </div>
               <div
                 v-if="isDropdownOpenAbout"
                 class="bg-yellow bg-opacity-70 divide-y divide-yellow shadow-lg w-44"
               >
                 <ul class="py-3 text-sm text-white">
                   <li>
                     <router-link
                       to="/about"
                       class="block px-4 py-3 hover:bg-white hover:text-black"
                       >About</router-link
                     >
                   </li>
                   <li>
                     <router-link
                       to="/achievements"
                       class="block px-4 py-3 hover:bg-white hover:text-black"
                       >Achievements</router-link
                     >
                   </li>
                   <li>
                     <router-link
                       to="/services"
                       class="block px-4 py-3 hover:bg-white hover:text-black"
                       >Services</router-link
                     >
                   </li>
                   <li>
                     <router-link
                       to="/career"
                       class="block px-4 py-3 hover:bg-white hover:text-black"
                       >Career</router-link
                     >
                   </li>
                   <li>
                     <router-link
                       to="/faq"
                       class="block px-4 py-3 hover:bg-white hover:text-black"
                       >FAQ</router-link
                     >
                   </li>
                 </ul>
               </div>
             </div>
   
             <!-- Properties Dropdown for Desktop -->
             <div class="relative">
               <div
                 @click="toggleDropdownProperties"
                 class="text-black flex items-center transition-all duration-300"
               >
                 Properties
                 <svg
                   class="w-2.5 h-2.5 ms-3"
                   xmlns="http://www.w3.org/2000/svg"
                   fill="none"
                   viewBox="0 0 10 6"
                 >
                   <path
                     stroke="currentColor"
                     stroke-linecap="round"
                     stroke-linejoin="round"
                     stroke-width="2"
                     d="m1 1 4 4 4-4"
                   />
                 </svg>
               </div>
               <div
                 v-if="isDropdownOpenProperties"
                 class="bg-yellow bg-opacity-70 divide-y divide-yellow shadow-lg w-44"
               >
                 <ul class="py-3 text-sm text-white">
                   <li>
                     <router-link
                       to="/ultra"
                       class="block px-4 py-3 hover:bg-white hover:text-black"
                       >Ultra</router-link
                     >
                   </li>
                   <li>
                     <router-link
                       to="/sites-and-services"
                       class="block px-4 py-3 hover:bg-white hover:text-black"
                       >Sites & Services</router-link
                     >
                   </li>
                   <li>
                     <router-link
                       to="/third-party-sale"
                       class="block px-4 py-3 hover:bg-white hover:text-black"
                       >Third Party Sale</router-link
                     >
                   </li>
                 </ul>
               </div>
             </div>
   
             <div class="relative">
               <div
                 @click="toggleDropdownBranches"
                 class="text-black flex items-center transition-all duration-300"
               >
                 Our Branches
                 <svg
                   class="w-2.5 h-2.5 ms-3"
                   xmlns="http://www.w3.org/2000/svg"
                   fill="none"
                   viewBox="0 0 10 6"
                 >
                   <path
                     stroke="currentColor"
                     stroke-linecap="round"
                     stroke-linejoin="round"
                     stroke-width="2"
                     d="m1 1 4 4 4-4"
                   />
                 </svg>
               </div>
               <div
                 v-if="isDropdownOpenBranches"
                 class="bg-yellow bg-opacity-70 divide-y divide-yellow shadow-lg w-44"
               >
                 <ul class="py-3 text-sm text-white">
                   <li>
                     <router-link
                       to="/lagos-branch"
                       class="block px-4 py-3 hover:bg-white hover:text-black"
                       >Lagos Branch</router-link
                     >
                   </li>
                   <li>
                     <router-link
                       to="/kano-branch"
                       class="block px-4 py-3 hover:bg-white hover:text-black"
                       >Kano Branch</router-link
                     >
                   </li>
                   <li>
                     <router-link
                       to="/yola-branch"
                       class="block px-4 py-3 hover:bg-white hover:text-black"
                       >Yola Branch</router-link
                     >
                   </li>
                 </ul>
               </div>
             </div>
   
             <router-link
               to="/contact-us"
               class="text-black transition-all duration-300"
               exact-active-class="active-link"
               >Contact</router-link
             >
   
             <!-- Login Dropdown for Desktop -->
             <div class="relative">
               <div
                 @click="toggleDropdownLogin"
                 class="text-black flex items-center transition-all duration-300"
               >
                 Login
                 <svg
                   class="w-2.5 h-2.5 ms-3"
                   xmlns="http://www.w3.org/2000/svg"
                   fill="none"
                   viewBox="0 0 10 6"
                 >
                   <path
                     stroke="currentColor"
                     stroke-linecap="round"
                     stroke-linejoin="round"
                     stroke-width="2"
                     d="m1 1 4 4 4-4"
                   />
                 </svg>
               </div>
               <div
                 v-if="isDropdownOpenLogin"
                 class="bg-yellow bg-opacity-70 divide-y divide-yellow shadow-lg w-44"
               >
                 <ul class="py-3 text-sm text-white">
                   <li>
                     <a
                       href="https://app.mshelhomes.com/login"
                       target="_blank"
                       class="block px-4 py-3 hover:bg-white hover:text-black"
                       >Staff</a
                     >
                   </li>
                   <li>
                     <a
                       href="https://app.mshelhomes.com/client-login"
                       target="_blank"
                       class="block px-4 py-3 hover:bg-white hover:text-black"
                       >Client</a
                     >
                   </li>
                 </ul>
               </div>
             </div>
   
             <!-- Register Dropdown for Desktop -->
             <div class="relative">
               <div
                 @click="toggleDropdownRegister"
                 class="text-black flex items-center transition-all duration-300"
               >
                 Register
                 <svg
                   class="w-2.5 h-2.5 ms-3"
                   xmlns="http://www.w3.org/2000/svg"
                   fill="none"
                   viewBox="0 0 10 6"
                 >
                   <path
                     stroke="currentColor"
                     stroke-linecap="round"
                     stroke-linejoin="round"
                     stroke-width="2"
                     d="m1 1 4 4 4-4"
                   />
                 </svg>
               </div>
               <div
                 v-if="isDropdownOpenRegister"
                 class="bg-yellow bg-opacity-70 divide-y divide-yellow shadow-lg w-44"
               >
                 <ul class="py-3 text-sm text-white">
                   <li><a href="https://app.mshelhomes.com/index.php/customercare" target="_blank" class="block px-4 py-3 hover:bg-white hover:text-black">Client</a></li>
                   <li><a href="https://app.mshelhomes.com/affiliates" target="_blank" class="block px-4 py-3 hover:bg-white hover:text-black">Affiliation</a></li>
                 </ul>
               </div>
             </div>
   
             <!-- Button (Inside Toggle on Mobile) -->
             <router-link to="/earn-with-us">
               <button
                 class="bg-yellow py-2 px-2 hover:bg-black hover:text-white transition-transform transform hover:scale-110 focus:outline-none focus:ring-4"
               >
                 Earn with us
               </button>
             </router-link>
           </nav>
         </div>
       </div>
    </div>
  </header>
</template>

<script>
import { useRoute } from "vue-router";
export default {
  data() {
    return {
      isMenuOpen: false,
      isDropdownOpenAbout: false,
      isDropdownOpenProperties: false,
      isDropdownOpenBranches: false,
      isDropdownOpenLogin: false,
      isDropdownOpenRegister: false,
    };
  },
  computed: {
    route() {
      return useRoute();
    },
    isAboutActive() {
      return [
        "/about",
        "/achievements",
        "/services",
        "/career",
        "/faq",
      ].includes(this.route.path);
    },
    isPropertiesActive() {
      return ["/ultra", "/sites-and-services", "/third-party-sale"].includes(
        this.route.path
      );
    },
    isBranchesActive() {
      return ["/lagos-branch", "/kano-branch", "/yola-branch"].includes(
        this.route.path
      );
    },
    isLoginActive() {
      return ["/staff", "/client"].includes(this.route.path);
    },
    isRegisterActive() {
      return ["/client", "/affiliation"].includes(this.route.path);
    },
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    toggleDropdownAbout() {
      this.isDropdownOpenAbout = !this.isDropdownOpenAbout;
    },
    toggleDropdownProperties() {
      this.isDropdownOpenProperties = !this.isDropdownOpenProperties;
    },
    toggleDropdownBranches() {
      this.isDropdownOpenBranches = !this.isDropdownOpenBranches;
    },
    toggleDropdownLogin() {
      this.isDropdownOpenLogin = !this.isDropdownOpenLogin;
    },
    toggleDropdownRegister() {
      this.isDropdownOpenRegister = !this.isDropdownOpenRegister;
    },
  },
};
</script>

<style scoped>
#dropdownHover {
  z-index: 1000;
}

.group:hover #dropdownHover {
  display: block;
}

.active-link {
  color: #ffffff;
  font-weight: 600;
  position: relative;
}

.active-link::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -8px;
  width: 6px;
  height: 6px;
  background-color: #e89e1c;
  border-radius: 50%;
}

.active-link .inline-flex::after {
  bottom: -10px;
}

.active-links::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -8px;
  width: 6px;
  height: 6px;
  background-color: #e89e1c;
  border-radius: 50%;
}

.active-links .inline-flex::after {
  bottom: -10px;
}

@media (max-width: 1024px) {
  #dropdownHover {
    display: none;
  }
}
</style>
